import { HTTP_CLIENT, ENDPOINTS } from "../utilities";

export const addContactApi = (params) => {
  return HTTP_CLIENT.post(ENDPOINTS.ADD_CONTACT, params);
};
